import { render, staticRenderFns } from "./OrderformBatch.vue?vue&type=template&id=870542f6&scoped=true"
import script from "./OrderformBatch.vue?vue&type=script&lang=js"
export * from "./OrderformBatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870542f6",
  null
  
)

export default component.exports